# utils_utest.coffee

export isHashComment = (text) ->

	return text.match(/^\s*#/)